(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["opus-custom-configurator"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('opus-configurator')) {
  customElements.define('opus-configurator', class extends HTMLElement {
    connectedCallback() {
      this.$ = (s) => this.querySelector(s);
      this.$$ = (s) => Array.from(this.querySelectorAll(s));
      this.SLOTS = ['face','motif','back','accent'];
      this.TABS = ['face','back','motif'];
      this.PATTERNS = ['solid','frame','monogram'];
      this.FONTS = ['cormorant','hanken'];
      this.NAMES = {'#F5FAFB':'Cool white','#FBF7F0':'Ivory','#FFF3E9':'Sand','#2E7A8F':'Pool blue','#1F5F70':'Deep pool','#7CB5D4':'Sky','#C9627A':'Coral rose','#A84E63':'Deep rose','#F3C6D2':'Blush','#E7C24B':'Sun gold','#E0865B':'Terracotta','#B23A48':'Classic red','#15303A':'Navy ink','#ECE6DA':'Pearl','#B0915F':'Antique gold','#6B4A2F':'Walnut'};
      const d = this.dataset;
      this.state = { face: d.defaultFace, motif: d.defaultMotif, back: d.defaultBack, accent: d.defaultAccent || '#E7C24B', pattern: 'frame', font: 'cormorant', text: '', line: d.defaultLine || 'floating', view: 'faces', slot: 'back' };
      this.live = this.$('[data-live]');
      this.restore();
      const ei = this.$('[data-engrave]'); if (ei) ei.value = this.state.text;
      this.apply();
      this.addEventListener('click', (e) => this.onClick(e));
      this.addEventListener('input', (e) => this.onInput(e));
      this.addEventListener('change', (e) => this.onChange(e));
    }
    isHex(c) { return /^#[0-9a-fA-F]{6}$/.test(c || ''); }
    reduced() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
    nameFor(hex) { return this.NAMES[(hex || '').toUpperCase()] || (hex || '').toUpperCase(); }
    slotName() { return { face: 'Face', back: 'Edge & back', motif: 'Engraving' }[this.state.slot]; }
    lineMeta(line) { const b = this.$('.opus-cfg__mat[data-line="' + line + '"]'); return b ? b.dataset : { label: '', price: '', note: '' }; }
    lineExists(l) { return !!this.$('.opus-cfg__mat[data-line="' + l + '"]'); }
    matchPreset() { return this.$$('.opus-cfg__preset').find(b => b.dataset.face === this.state.face && b.dataset.motif === this.state.motif && b.dataset.back === this.state.back && b.dataset.accent === this.state.accent); }
    onClick(e) {
      const t = e.target; let b;
      if ((b = t.closest('[data-preset]'))) { Object.assign(this.state, { face: b.dataset.face, motif: b.dataset.motif, back: b.dataset.back, accent: b.dataset.accent }); this.apply('Palette ' + (b.dataset.name || '') + ' applied'); return; }
      if ((b = t.closest('.opus-cfg__slot'))) { this.state.slot = b.dataset.slot; this.apply(); return; }
      if ((b = t.closest('.opus-cfg__chip'))) { this.state[this.state.slot] = b.dataset.color; this.apply(this.slotName() + ' set to ' + this.nameFor(b.dataset.color)); return; }
      if ((b = t.closest('.opus-cfg__style'))) { this.state.pattern = b.dataset.pattern; this.apply('Back: ' + b.textContent.trim()); return; }
      if ((b = t.closest('.opus-cfg__font'))) { this.state.font = b.dataset.font; this.apply(); return; }
      if ((b = t.closest('.opus-cfg__mat'))) { this.state.line = b.dataset.line; this.apply((b.dataset.label || '') + ' selected'); return; }
      if ((b = t.closest('[data-view]'))) { this.state.view = b.dataset.view; this.apply('Showing tile ' + this.state.view); return; }
      if (t.closest('[data-submit]')) { this.sendToForm(); return; }
    }
    onInput(e) {
      const t = e.target;
      if (t.matches('[data-wheel]')) { this.state[this.state.slot] = t.value; this.apply(); }
      if (t.matches('[data-engrave]')) { this.state.text = t.value.slice(0, 16); this.apply(); }
    }
    onChange(e) {
      const t = e.target;
      if (t.matches('[data-wheel]') && this.live) this.live.textContent = this.slotName() + ' set to ' + this.nameFor(t.value);
      if (t.matches('[data-engrave]') && this.live) this.live.textContent = this.state.text ? 'Engraving: ' + this.state.text : 'Engraving cleared';
    }
    apply(announce) {
      const s = this.state;
      this.SLOTS.forEach(k => this.style.setProperty('--' + k, s[k]));
      this.dataset.view = s.view; this.dataset.pattern = s.pattern; this.dataset.font = s.font; this.dataset.line = s.line; this.dataset.slot = s.slot;
      this.$$('[data-engrave-target]').forEach(x => x.textContent = s.text || 'YOUR NAME');
      this.$$('[data-dot]').forEach(x => x.style.background = s[x.dataset.dot]);
      this.$$('[data-view]').forEach(x => x.setAttribute('aria-pressed', String(x.dataset.view === s.view)));
      this.$$('.opus-cfg__slot').forEach(x => x.setAttribute('aria-pressed', String(x.dataset.slot === s.slot)));
      this.$$('.opus-cfg__chip').forEach(x => x.setAttribute('aria-pressed', String((x.dataset.color || '').toLowerCase() === (s[s.slot] || '').toLowerCase())));
      const wheel = this.$('[data-wheel]'); if (wheel && this.isHex(s[s.slot])) wheel.value = s[s.slot];
      this.$$('.opus-cfg__style').forEach(x => x.setAttribute('aria-pressed', String(x.dataset.pattern === s.pattern)));
      this.$$('.opus-cfg__font').forEach(x => x.setAttribute('aria-pressed', String(x.dataset.font === s.font)));
      this.$$('.opus-cfg__mat').forEach(x => x.setAttribute('aria-pressed', String(x.dataset.line === s.line)));
      const lm = this.lineMeta(s.line);
      const set = (sel, v) => { const x = this.$(sel); if (x) x.textContent = v; };
      set('[data-cap-line]', lm.label || ''); set('[data-cap-note]', lm.note || '');
      set('[data-sum-face]', this.nameFor(s.face)); set('[data-sum-back]', this.nameFor(s.back)); set('[data-sum-motif]', this.nameFor(s.motif));
      const styleBtn = this.$('.opus-cfg__style[data-pattern="' + s.pattern + '"]');
      set('[data-sum-pattern]', styleBtn ? styleBtn.textContent.trim() : '');
      set('[data-sum-engrave]', s.text ? '“' + s.text + '” · ' + (s.font === 'cormorant' ? 'Cormorant' : 'Hanken') : '—');
      set('[data-sum-line]', (lm.label || '') + (lm.price ? ' · ' + lm.price : ''));
      const mp = this.matchPreset();
      set('[data-sum-palette]', mp ? (mp.dataset.name || 'Custom') : 'Custom');
      this.$$('.opus-cfg__preset').forEach(x => x.setAttribute('aria-pressed', String(!!mp && x === mp)));
      const cc = this.$('[data-charcount]'); if (cc) cc.textContent = (s.text || '').length;
      const brief = this.$('[data-brief]'); if (brief) brief.value = this.buildBrief();
      this.writeURL();
      this.fillForm();
      if (announce && this.live) this.live.textContent = announce;
    }
    buildBrief() {
      const s = this.state, lm = this.lineMeta(s.line), styleBtn = this.$('.opus-cfg__style[data-pattern="' + s.pattern + '"]');
      const style = styleBtn ? styleBtn.textContent.trim() : s.pattern;
      return ['OPUS MAHJONG — CUSTOM DESIGN BRIEF', '----------------------------------',
        'Line:      ' + (lm.label || '') + (lm.price ? ' (' + lm.price + ')' : ''),
        'Face:      ' + this.nameFor(s.face) + '  ' + s.face,
        'Edge/back: ' + this.nameFor(s.back) + '  ' + s.back + '  (' + style + ' back)',
        'Engraving: ' + (s.text ? '“' + s.text + '” in ' + (s.font === 'cormorant' ? 'Cormorant' : 'Hanken') + ' (' + this.nameFor(s.motif) + ' ' + s.motif + ')' : '(none)'),
        '', 'Reload code: ' + this.encode()].join('\n');
    }
    encode() { try { return btoa(unescape(encodeURIComponent(JSON.stringify(this.state)))); } catch (e) { return ''; } }
    writeURL() { clearTimeout(this._t); this._t = setTimeout(() => { try { const u = new URL(window.location.href); u.searchParams.set('d', this.encode()); window.history.replaceState(null, '', u); } catch (e) {} }, 200); }
    restore() {
      try {
        const raw = new URL(window.location.href).searchParams.get('d'); if (!raw) return;
        const o = JSON.parse(decodeURIComponent(escape(atob(raw)))), s = this.state;
        ['face','motif','back','accent'].forEach(k => { if (this.isHex(o[k])) s[k] = o[k]; });
        if (this.PATTERNS.includes(o.pattern)) s.pattern = o.pattern;
        if (this.FONTS.includes(o.font)) s.font = o.font;
        if (this.lineExists(o.line)) s.line = o.line;
        if (['faces','backs'].includes(o.view)) s.view = o.view;
        if (this.TABS.includes(o.slot)) s.slot = o.slot;
        if (typeof o.text === 'string') s.text = o.text.slice(0, 16);
      } catch (e) {}
    }
    form() { return document.querySelector(this.dataset.targetForm || '.opus-leadgen__form'); }
    ensureFields(f) {
      if (!f) return null;
      let a = f.querySelector('[name="contact[Design brief]"]'), b = f.querySelector('[name="contact[Design summary]"]');
      if (!a) { a = document.createElement('input'); a.type = 'hidden'; a.name = 'contact[Design brief]'; f.appendChild(a); }
      if (!b) { b = document.createElement('input'); b.type = 'hidden'; b.name = 'contact[Design summary]'; f.appendChild(b); }
      return { a: a, b: b };
    }
    fillForm() { const f = this.form(); if (!f) return; const fl = this.ensureFields(f); if (!fl) return; fl.a.value = this.buildBrief(); fl.b.value = this.encode(); }
    sendToForm() {
      const f = this.form(); this.fillForm();
      if (f) {
        f.scrollIntoView({ behavior: this.reduced() ? 'auto' : 'smooth', block: 'start' });
        const inp = f.querySelector('input[type=email], input[type=text]');
        if (inp) setTimeout(() => inp.focus(), this.reduced() ? 0 : 500);
        if (this.live) this.live.textContent = 'Your design was added to the quote form below.';
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["opus-how-to-play"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('htp-guide')) {
  customElements.define('htp-guide', class extends HTMLElement {
    connectedCallback() {
      this.flowerSrc = this.dataset.flower || '';
      this.buildHands();
      this.wireMeet();
      this.wireDecoder();
      this.wirePrint();
    }
    tile(inner, edge) {
      const s = document.createElement('span');
      s.className = 'htp-mtile';
      if (edge) s.style.setProperty('--edge', edge);
      s.innerHTML = inner;
      return s;
    }
    dot(n, edge) {
      let dots = '';
      for (let i = 0; i < n; i++) dots += '<i></i>';
      return this.tile('<span class="htp-dots htp-dots--' + n + '">' + dots + '</span>', edge);
    }
    soap(edge) { return this.tile('<span class="htp-soap"><b>0</b></span>', edge); }
    flower() {
      const s = this.tile('', 'var(--htp-rose)');
      const img = document.createElement('img');
      img.src = this.flowerSrc; img.alt = 'Flower'; img.loading = 'lazy';
      s.appendChild(img);
      return s;
    }
    group(spec) {
      const parts = spec.split(':');
      const type = parts[0];
      const val = parseInt(parts[1], 10);
      const suit = parts[parts.length - 1];
      const edge = suit === 'rose' ? 'var(--htp-rose)' : 'var(--htp-pool)';
      const frag = document.createDocumentFragment();
      if (type === 'FF') { frag.appendChild(this.flower()); frag.appendChild(this.flower()); }
      else if (type === 'kong') { for (let i = 0; i < 4; i++) frag.appendChild(this.dot(val, edge)); }
      else if (type === 'pair') { frag.appendChild(this.dot(val, edge)); frag.appendChild(this.dot(val, edge)); }
      else if (type === 'year') {
        const yr = (this.dataset.year || '').toString();
        const digits = /^\d{4}$/.test(yr) ? yr.split('') : ['2', '0', '2', '6'];
        digits.forEach(d => { const n = parseInt(d, 10); frag.appendChild(n === 0 ? this.soap(edge) : this.dot(n, edge)); });
      }
      return frag;
    }
    buildHands() {
      this.querySelectorAll('.htp-grp[data-build]').forEach(g => {
        g.appendChild(this.group(g.dataset.build));
      });
    }
    wireMeet() {
      const row = this.querySelector('[data-meet]');
      const cap = this.querySelector('[data-meet-cap]');
      if (!row || !cap) return;
      row.addEventListener('click', e => {
        const b = e.target.closest('button'); if (!b) return;
        row.querySelectorAll('button').forEach(x => x.setAttribute('aria-pressed', String(x === b)));
        cap.innerHTML = '<b></b><span></span>';
        cap.querySelector('b').textContent = b.dataset.n || '';
        cap.querySelector('span').textContent = b.dataset.d || '';
      });
    }
    wireDecoder() {
      const lines = Array.from(this.querySelectorAll('.htp-line'));
      const panels = Array.from(this.querySelectorAll('.htp-decode'));
      const live = this.querySelector('[data-live]');
      lines.forEach(l => l.addEventListener('click', () => {
        lines.forEach(x => x.setAttribute('aria-pressed', String(x === l)));
        const key = l.dataset.hand;
        panels.forEach(p => { p.hidden = p.dataset.decode !== key; });
        if (live) { const name = panels.find(p => p.dataset.decode === key); live.textContent = name ? ('Showing hand: ' + (name.querySelector('.htp-stage__name') || {}).textContent) : ''; }
      }));
    }
    wirePrint() {
      const btn = this.querySelector('[data-print]');
      if (btn) btn.addEventListener('click', () => window.print());
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["opus-product-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('opus-review-grid')) {
  customElements.define('opus-review-grid', class extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('.opus-prev__grid');
      this.btn = this.querySelector('[data-review-more]');
      if (!this.grid || !this.btn) return;
      this.btn.addEventListener('click', () => this.toggle());
    }
    toggle() {
      const expanded = this.grid.classList.toggle('is-expanded');
      this.btn.setAttribute('aria-expanded', String(expanded));
      const label = this.btn.querySelector('[data-more-text]');
      const count = this.btn.querySelector('.opus-prev__more-count');
      if (label) label.textContent = expanded ? (this.btn.dataset.less || 'Show fewer') : (this.btn.dataset.more || 'Show all reviews');
      if (count) count.hidden = expanded;
      if (!expanded) this.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["opus-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('opus-reviews')) {
  customElements.define('opus-reviews', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.opus-rev__track');
      if (!this.track) return;
      this.slides = Array.from(this.track.children);
      this.index = 0;
      this.userPaused = false;
      this.autoplay = this.dataset.autoplay === 'true';
      this.interval = (parseFloat(this.dataset.interval) || 6) * 1000;
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.timer = null;

      const prev = this.querySelector('[data-rev-prev]');
      const next = this.querySelector('[data-rev-next]');
      const toggle = this.querySelector('[data-rev-toggle]');
      if (prev) prev.addEventListener('click', () => { this.userPaused = true; this.stop(); this.go(this.index - 1); this.reflectToggle(); });
      if (next) next.addEventListener('click', () => { this.userPaused = true; this.stop(); this.go(this.index + 1); this.reflectToggle(); });
      if (toggle) toggle.addEventListener('click', () => this.toggle());

      this.addEventListener('pointerenter', () => this.stop());
      this.addEventListener('pointerleave', () => this.resume());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.resume());

      let st;
      this.track.addEventListener('scroll', () => { clearTimeout(st); st = setTimeout(() => this.syncIndex(), 120); }, { passive: true });
      document.addEventListener('visibilitychange', () => { if (document.hidden) { this.stop(); } else { this.resume(); } });

      if (this.canAuto()) this.start();
    }
    disconnectedCallback() { this.stop(); }
    canAuto() { return this.autoplay && !this.reduce && !this.userPaused && this.slides.length > 1; }
    go(i) {
      const n = this.slides.length;
      this.index = ((i % n) + n) % n;
      const slide = this.slides[this.index];
      this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior: this.reduce ? 'auto' : 'smooth' });
    }
    syncIndex() {
      const x = this.track.scrollLeft;
      let best = 0, bestD = Infinity;
      this.slides.forEach((s, i) => { const d = Math.abs((s.offsetLeft - this.track.offsetLeft) - x); if (d < bestD) { bestD = d; best = i; } });
      this.index = best;
    }
    start() { this.stop(); this.setAttribute('data-paused', 'false'); this.timer = setInterval(() => this.go(this.index + 1), this.interval); }
    stop() { if (this.timer) { clearInterval(this.timer); this.timer = null; } }
    resume() { if (this.canAuto() && !this.timer) this.start(); }
    reflectToggle() {
      const btn = this.querySelector('[data-rev-toggle]');
      this.setAttribute('data-paused', this.userPaused ? 'true' : 'false');
      if (btn) { btn.setAttribute('aria-pressed', String(this.userPaused)); btn.setAttribute('aria-label', this.userPaused ? 'Play auto-rotation' : 'Pause auto-rotation'); }
    }
    toggle() {
      this.userPaused = !this.userPaused;
      if (this.userPaused) this.stop(); else this.start();
      this.reflectToggle();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["opus-wholesale"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('opus-wholesale')) {
  customElements.define('opus-wholesale', class extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (e) => {
        const lane = e.target.closest('[data-lane]');
        const scroll = e.target.closest('[data-scroll]');
        if (!lane && !scroll) return;
        const form = document.querySelector('.opus-leadgen');
        if (!form) return;
        if (lane) {
          const sel = form.querySelector('select[name="contact[Inquiry type]"]');
          if (sel) {
            Array.from(sel.options).forEach((o) => { if (o.value === lane.dataset.lane) sel.value = o.value; });
          }
          const live = this.querySelector('[data-live]');
          if (live) live.textContent = lane.dataset.lane + ' — pricing request form below.';
        }
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        form.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
        const focusable = form.querySelector('input[type=email], input, select');
        if (focusable) setTimeout(() => focusable.focus(), reduced ? 0 : 500);
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
